"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var ElevenLabsFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M235.86 64v896h184.12V64zm368.16 0v896h184.12V64z" } }] }, "name": "eleven-labs", "theme": "filled" };
exports.default = ElevenLabsFilled;
